import * as React from 'react';

import Room from '../../models/Room';

interface P {
    room: Room;
    checked: boolean;
    onChecked?: (room: Room) => void;
    onCleared?: (room: Room) => void;
}

export default class RoomCell extends React.Component<P, {}> {

    private get soldout() {
        return !this.props.room.id;
    }

    private toggle() {
        if ( !this.props.checked )
            this.props.onChecked && this.props.onChecked( this.props.room );
        else
            this.props.onCleared && this.props.onCleared( this.props.room );
    }

    render() {
        let checked = this.props.checked ? 'checked' : '';
        let soldout = this.soldout ? 'soldout' : '';

        let { room } = this.props;
        let { kind } = room;

        return (
            <div className={ `${checked} ${soldout} ${kind.abbr}-${room.name} cell` }
                 onClick={ () => this.soldout || this.toggle() }>
              <div>
                <div className="name">{ room.name }</div>
                <div className="type">{ kind.name }</div>
                <div className="occupancy">
                  { kind.lo && `${kind.lo} ~ `}
                  { kind.hi } People
                </div>
              </div>
            </div>
        );
    }

}



/** WEBPACK FOOTER **
 ** ./src/components/booking/RoomCell.tsx
 **/